import type { ConfigType } from '@plone/registry';
import type { BlockConfigBase } from '@plone/types';
import cloneDeep from 'lodash/cloneDeep';
import { ImageSliderDataAdapter } from '../../components/ImageSlider/adapter';
import ImageSliderEdit from '../../components/ImageSlider/Edit';
import ImageSliderView from '../../components/ImageSlider/View';
import {
  InfoEventBlockView,
  InfoEventBlockEdit,
} from '../../components/InfoEvent/index';

// Import icons directly from Volto
import imagesSVG from '@plone/volto/icons/images.svg';
import infoSVG from '@plone/volto/icons/info.svg';
import showBlocksSVG from '@plone/volto/icons/show-blocks.svg';
import columnSVG from '@plone/volto/icons/column.svg';

/**
 * Configure media blocks
 * Follows SOLID principles by grouping media-related block configurations
 */
export const configureMediaBlocks = (config: ConfigType) => {
  // Image slider block configuration
  config.blocks.blocksConfig.imageslider = {
    id: 'imageslider',
    title: 'Bildergalerie',
    icon: imagesSVG,
    group: 'media',
    view: ImageSliderView,
    edit: ImageSliderEdit,
    dataAdapter: ImageSliderDataAdapter,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    enableStyling: false,
  };

  return config;
};

/**
 * Configure layout blocks
 * Follows SOLID principles by grouping layout-related block configurations
 */
export const configureLayoutBlocks = (config: ConfigType) => {
  // Group block configuration
  config.blocks.blocksConfig.group = {
    ...config.blocks.blocksConfig.group,
    title: 'Gruppe',
    icon: showBlocksSVG,
    group: 'layout',
  };

  // Grid block configuration
  config.blocks.blocksConfig.gridBlock = {
    ...config.blocks.blocksConfig.gridBlock,
    title: 'Spalten',
    icon: columnSVG,
    group: 'layout',
    blocksConfig: cloneDeep(config.blocks.blocksConfig),
    allowedBlocks: ['image', 'listing', 'slate', 'teaser', 'video', 'buttons'],
  } as BlockConfigBase & { allowedBlocks: string[] };

  return config;
};

/**
 * Configure eduproduct blocks
 * Follows SOLID principles by grouping education product-related block configurations
 */
export const configureEduProductBlocks = (config: ConfigType) => {
  // Info event block configuration - using direct Volto icon
  config.blocks.blocksConfig.infoevent = {
    id: 'infoevent',
    title: 'Info-Anlass Teaser',
    icon: infoSVG,
    group: 'eduproduct',
    view: InfoEventBlockView,
    edit: InfoEventBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  return config;
};

/**
 * Configure text blocks
 * Follows SOLID principles by grouping text-related block configurations
 */
export const configureTextBlocks = (config: ConfigType) => {
  // Heading block configuration
  config.blocks.blocksConfig.heading = {
    ...config.blocks.blocksConfig.heading,
    allowed_headings: ['h2', 'h3', 'h4', 'h5', 'h6'],
    schemaEnhancer: null,
  };

  return config;
};
